import React, { useEffect, useRef, useCallback } from 'react'
import { array } from 'prop-types'
import _ from 'lodash'

import { toastr } from 'components/Toastr'
import { useLocalStorage } from 'hooks/useLocalStorage'
import { ContractUpdateMessage } from './ContractUpdateMessage'

import {
  objectifyPipelineStatus,
  statusDiff,
  changedContractStatus,
} from './helpers'

const LS_DIFF_OFF_ASSIGNMENTS_STATUS =
  '__sales-engagement__surprise-diff-of-assignments-status'

const LS_ACTIVE_IDS_TOASTR_OF_CONTRACT_UPDATE =
  '__sales-engagement__surprise-active-ids-toastr-of-contract-update'

const StatusUpdate = ({ assignments }) => {
  const alreadyDisplayedIds = useRef([])
  const [status, setStatus] = useLocalStorage(
    LS_DIFF_OFF_ASSIGNMENTS_STATUS,
    {},
  )
  const [activeIds, setActiveIds] = useLocalStorage(
    LS_ACTIVE_IDS_TOASTR_OF_CONTRACT_UPDATE,
    [],
  )

  const displayToastrInfo = useCallback(
    (currentId, fullName) => {
      alreadyDisplayedIds.current = [...alreadyDisplayedIds.current, currentId]
      toastr.info(<ContractUpdateMessage name={fullName} id={currentId} />, {
        onClose: () => {
          setActiveIds(activeIds.filter(id => currentId !== id))
          alreadyDisplayedIds.current = alreadyDisplayedIds.current.filter(
            id => currentId !== id,
          )
        },
      })
    },
    [alreadyDisplayedIds, activeIds, setActiveIds],
  )

  useEffect(() => {
    const dataTransformed = objectifyPipelineStatus(assignments)
    if (!_.isEqual(dataTransformed, status)) {
      const diff = statusDiff(dataTransformed, status)
      const list = changedContractStatus(diff)

      setStatus(dataTransformed)

      for (const currentId of list) {
        const customer = assignments.find(c => c.id === currentId)
        setActiveIds([...activeIds, currentId])
        displayToastrInfo(currentId, customer.fullName)
      }
    }
  }, [
    status,
    assignments,
    setStatus,
    activeIds,
    setActiveIds,
    displayToastrInfo,
  ])

  useEffect(() => {
    const diff = _.difference(activeIds, alreadyDisplayedIds.current)

    for (const currentId of diff) {
      const customer = assignments.find(c => c.id === currentId)
      if (customer) {
        displayToastrInfo(currentId, customer.fullName)
      } else {
        setActiveIds(activeIds.filter(id => currentId !== id))
      }
    }
  }, [assignments, activeIds, setActiveIds, displayToastrInfo])

  return <></>
}

StatusUpdate.propTypes = {
  assignments: array,
}

export { StatusUpdate }
